module.exports = __webpack_public_path__ + "media/site_templates/www.tilingquotes.com.au/images/our_services_1-8060308c1e414c90ab987c4a6ac2592e.jpg";